import {onWindowResize} from "../utilities/hooks";
import {mediaBreakpointDown} from "../utilities/MediaBreakpoints";
import ComponentClass from "../utilities/ComponentClass";
import {Store} from "../store";

export class NavDropdown extends ComponentClass.EventComponent {
    dropdownElement = null;
    navbarElement = null;
    buttonElement = null;
    menuElement = null;
    backdropElement = null;
    dataColor = '';
    #config = {
        durationIn: 0,
        durationOut: 600
    }
    state = {
        visible: false,
        isPointerEventsEnabled: true
    }

    constructor(dropdownElement) {
        super();
        this.dropdownElement = dropdownElement;
        this.buttonElement = dropdownElement.querySelector('[data-type="nav-dropdown"]');
        this.menuElement = dropdownElement.querySelector('.nav-dropdown-menu').cloneNode(true);
        this.navbarElement = document.querySelector('nav.navbar');
        this.dataColor = this.buttonElement.dataset.color;
        this.main();
    }

    main() {
        this.buttonElement.addEventListener('click', (event) => this.handleDropdown(event), false);
        [...this.menuElement.querySelectorAll('a')].map(e => e.addEventListener('click', () => this.hide(), false));
        this.menuElement.setAttribute('data-color', this.dataColor);
        this.setupBackdropEvent();
    }

    setupBackdropEvent() {
        const backdropElement = document.createElement('div');
        backdropElement.className = 'nav-dropdown-backdrop';
        backdropElement.addEventListener('click', (e) => this.handleDropdown(e), false);
        this.backdropElement = backdropElement;
    }

    handleDropdown(event) {
        event.preventDefault();
        if (!this.state.isPointerEventsEnabled) return;
        this.toggle();
    }

    toggle() {
        this.state.visible ? this.hide() : this.show();
    }

    hide() {
        this.setState({isPointerEventsEnabled: false});
        this.destroyBackdrop();
        this.transitionLeave(() => {
            this.setState({isPointerEventsEnabled: true, visible: false});
            this.emitEventHidden();
        });
    }

    show() {
        this.setState({isPointerEventsEnabled: false});
        this.renderBackdrop();
        this.transitionEnter(() => {
            this.setState({isPointerEventsEnabled: true, visible: true});
            this.emitEventShown();
        });
    }

    renderBackdrop() {
        this.navbarElement.after(this.backdropElement);
    }

    destroyBackdrop() {
        this.backdropElement.remove();
    }

    transitionEnter(hook) {
        this.navbarElement.after(this.menuElement);
        this.dropdownElement.classList.add('expanded');
        setTimeout(() => {
            this.menuElement.classList.add('show');
            hook();
        }, this.#config.durationIn);
    }

    transitionLeave(hook) {
        this.menuElement.classList.add('hide');
        setTimeout(() => {
            this.menuElement.remove();
            this.dropdownElement.classList.remove('expanded');
            this.menuElement.classList.remove('hide');
            this.menuElement.classList.remove('show');
            hook();
        }, this.#config.durationOut);
    }

    emitEventShown() {
        this.dispatchEvent(
            new CustomEvent('dropdown.menu.shown', {
                detail: {
                    visible: this.state.visible,
                    state: this.state,
                    instance: this
                }
            })
        );
    }

    emitEventHidden() {
        this.dispatchEvent(
            new CustomEvent('dropdown.menu.hidden', {
                detail: {
                    visible: this.state.visible,
                    state: this.state,
                    instance: this
                }
            })
        );
    }

}

const dropdownMenuInstanceList = [];


/**
 *
 * @param {boolean} visible
 * @param {NavDropdown} instance
 * @return {NavDropdown[]}
 */
function findOtherVisibleInstancesExcludingCurrent({state, instance}) {
    return dropdownMenuInstanceList.filter(e => e !== instance && e.state.visible === state.visible);
}

/**
 *
 * @return {NavDropdown | undefined}
 */
function findVisibleDropdownInstances() {
    return dropdownMenuInstanceList.find(e => e.state.visible);
}

/**
 * Hide visible NavDropdown instances when a new instance is being visible
 * @param {Object} detail
 * @return void
 */
function handleDropdownMenuShown({detail}) {
    // Check if clone hyperlinks has already been commited to store
    if (!Store.state.dropdownHyperLinks.length) {
        const dropdownLinks = dropdownMenuInstanceList.map(e => [...e.menuElement.querySelectorAll('a')]).flat();
        Store.commit((state) => ({
            dropdownLinks: state.dropdownHyperLinks.push(...dropdownLinks)
        }));
        // Store.state.router.updateHyperlinks(Store.state.dropdownHyperLinks);
    }
    document.body.classList.add('nav-dropdown-expanded');
    const filteredInstances = findOtherVisibleInstancesExcludingCurrent(detail);
    if (filteredInstances.length > 0) {
        filteredInstances.map(e => e.hide());
    }
}

function handleDropdownMenuHidden() {
    const dropdownsVisible = findVisibleDropdownInstances();
    if (typeof dropdownsVisible === 'undefined') {
        document.body.classList.remove('nav-dropdown-expanded');
    } else {
        document.body.classList.add('nav-dropdown-expanded');
    }
}

function hideNavDropdownOnMobile() {
    const isAnyDropdownOpen = findVisibleDropdownInstances();
    if (isAnyDropdownOpen instanceof NavDropdown) {
        isAnyDropdownOpen.hide();
    }
}

onWindowResize(() => {
    if (mediaBreakpointDown('lg')) {
        hideNavDropdownOnMobile()
    }
});

export default function useNavDropdown() {
    if (mediaBreakpointDown('lg')) return;
    for (const dropdown of document.querySelectorAll('.nav-dropdown')) {
        const dropdownInstance = new NavDropdown(dropdown);
        dropdownInstance.addEventListener('dropdown.menu.shown', handleDropdownMenuShown, false);
        dropdownInstance.addEventListener('dropdown.menu.hidden', handleDropdownMenuHidden, false);
        dropdownMenuInstanceList.push(dropdownInstance);
    }
    Store.commit({navDropdownInstanceList: dropdownMenuInstanceList})
}
